
<app-content-page-layout title="Meal Plan">
  <p>Meal plan works!</p>
</app-content-page-layout>